import { account } from 'se-bank-account';
import { digitsOnly } from './validation.utils';
import { ParsedSwedishBankAccount } from './validation.models';

type SeBankAccountResult = {
  bank?: string;
  clearing?: string | number;
  number?: string | number;
};

export function getBankNameFromClearing(_clearingRaw: string): string | null {
  return null;
}

export function parseSwedishBankAccount(
  clearingRaw: string,
  accountNumberRaw: string
): ParsedSwedishBankAccount {
  const clearing = digitsOnly(clearingRaw);
  const accountNumber = digitsOnly(accountNumberRaw);

  if (!clearing || !accountNumber) {
    return {
      isValid: false,
      clearing,
      accountNumber,
      bankName: null,
      normalized: null,
      errors: ['validation.invalid-account-number-default']
    };
  }

  if (clearing.length < 4 || clearing.length > 5) {
    return {
      isValid: false,
      clearing,
      accountNumber,
      bankName: null,
      normalized: null,
      errors: ['validation.invalid-clearing-default']
    };
  }

  try {
    const parsed = account(`${clearing}${accountNumber}`) as SeBankAccountResult | false;

    if (!parsed) {
      return {
        isValid: false,
        clearing,
        accountNumber,
        bankName: null,
        normalized: null,
        errors: ['validation.invalid-account-number-default']
      };
    }

    const parsedClearing = String(parsed.clearing ?? clearing);
    const parsedAccountNumber = String(parsed.number ?? accountNumber);
    const bankName = parsed.bank ?? null;

    return {
      isValid: true,
      clearing: parsedClearing,
      accountNumber: parsedAccountNumber,
      bankName,
      normalized: `${parsedClearing}${parsedAccountNumber}`,
      errors: []
    };
  } catch {
    return {
      isValid: false,
      clearing,
      accountNumber,
      bankName: null,
      normalized: null,
      errors: ['validation.invalid-account-number-default']
    };
  }
}